module.exports = __webpack_public_path__ + "static/gm-13-cabc65306a6c84940506d738078dd498.jpg";